module.exports = __webpack_public_path__ + "img/lg_ring_y_o_0_null@3x.06ff99c6.png";